import { queryOptions, useIsFetching, useIsMutating, useQueryClient } from '@tanstack/react-query';
import {
  ProposalsInfosGetEditProposalInformationRequest,
  ProposalsInfosGetProposalDataLossRequest
} from 'bff';
import { minutesToMilliseconds } from 'date-fns';
import { clientService } from 'stores/client-store/client-store';

const proposalPrefix = 'proposal';

export const useInvalidateGetProposal = () => {
  const queryClient = useQueryClient();

  return async () =>
    await queryClient.invalidateQueries({
      queryKey: [proposalPrefix, 'useGetProposalById']
    });
};

/**
 * @returns The number of queries currently fetching with a query key beginning with "proposal"
 */
export const useIsQueryingProposals = () => {
  return useIsFetching({
    queryKey: [proposalPrefix]
  });
};

/**
 * @returns The number of queries currently mutating with a mutation key beginning with "proposal"
 */
export const useIsMutatingProposals = () => {
  return useIsMutating({
    mutationKey: [proposalPrefix]
  });
};

export const useInvalidateProposalInformation = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [proposalPrefix, 'useGetEditProposalInformation'],
      refetchType: 'all'
    });
};

export const getEditProposalInformation = (
  getProposalRequest: ProposalsInfosGetEditProposalInformationRequest
) => {
  const { proposalsInfosApi } = clientService.getApiClient();
  return queryOptions({
    queryKey: [proposalPrefix, 'useGetEditProposalInformation', getProposalRequest],
    queryFn: () => proposalsInfosApi.proposalsInfosGetEditProposalInformation(getProposalRequest),
    select: (response) => response.data!,
    staleTime: minutesToMilliseconds(5)
  });
};

export const getProposalDataLoss = (
  getDataLossRequest: ProposalsInfosGetProposalDataLossRequest
) => {
  const { proposalsInfosApi } = clientService.getApiClient();
  return queryOptions({
    queryKey: [proposalPrefix, 'useGetProposalDataLoss', getDataLossRequest],
    queryFn: () => proposalsInfosApi.proposalsInfosGetProposalDataLoss(getDataLossRequest),
    select: (response) => response.data!,
    staleTime: 0
  });
};
